import { Pipe, PipeTransform } from '@angular/core';
import { Identity } from 'app/models/api/identity';
import { Tenant } from 'app/models/api/tenants';

@Pipe({
  name: 'selectedTenant',
})
export class SelectedTenantPipe implements PipeTransform {
  transform(profile: Identity | undefined): Tenant | null {
    if (!profile) {
      return null;
    }

    return profile.tenants?.find(t => t.id === profile.currentTenantId) || null;
  }
}
